import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import BulkIdRegisterForm from './Components/BulkIdRegisterForm';
import LoginPageWrapper from '../Components/LoginPageWrapper';
import './BulkRegisterId.scss';

function BulkIdRegister(props) {
  const { init, clearLoginFail } = props;

  useEffect(() => {
    init();
    // eslint-disable-next-line
    return () => {
      clearLoginFail();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LoginPageWrapper className="react-page-bulk-id-register-page">
      <BulkIdRegisterForm {...props} />
    </LoginPageWrapper>
  );
}

BulkIdRegister.propTypes = {
  init: PropTypes.func.isRequired,
  clearLoginFail: PropTypes.func.isRequired,
};

export default BulkIdRegister;
